import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { IDeleteResponse } from './workspace/interfaces/delete-response.interface';
import { catchError } from 'rxjs/operators';

export class Api {

  public readonly apiUrl = 'http://xn----7sbbo1akkddft7k.xn--p1ai:49370';

  constructor(
    protected readonly http: HttpClient,
    protected readonly authService,
    private methodName: string
  ) { }

  get<R>(path?: string): Observable<R> {
    return this.http.get(this.apiUrl + '/' + this.methodName + (path || ''), { headers: this.getHeaders() })
      .pipe(catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && this.authService) {
          this.authService.unauthorized$.next();
        }
        return of(undefined);
      })) as Observable<R>;
  }

  getItem<R>(id: string): Observable<R> {
    return this.get('/' + id);
  }

  post<T>(body: T, path?: string) {
    return this.http.post(this.apiUrl + '/' + this.methodName + (path || ''), body, { headers: this.getHeaders() });
  }

  put<T>(body: T, path?: string) {
    return this.http.put(this.apiUrl + '/' + this.methodName + (path || ''), body, { headers: this.getHeaders() });
  }

  delete(id?: string): Observable<IDeleteResponse> {
    return this.http.delete(
      this.apiUrl + '/' + this.methodName + (id ? '/' + id : ''),
      { headers: this.getHeaders() }
    ) as Observable<IDeleteResponse>;
  }

  private getHeaders(): any {
    const headers: any = {
      'Content-Type': 'application/json',
    };
    if (this.authService) {
      headers.Authorization = 'Bearer ' + this.authService.getToken();
    }
    return new HttpHeaders(headers);
  }

}
